<template>
  <button
    @click="go"
    :disabled="!props.href"
    :class="{ disabled: !props.href }"
  >
    {{ props.text }}
  </button>
</template>

<script setup>
const props = defineProps({
  text: { type: String, required: true },
  href: { type: String, required: false },
});

const go = () => {
  if (props.href) window.open(props.href);
};
</script>

<style scoped>
button {
  position: relative;
  padding: 3rem 1rem;
  /* border-radius: 1rem; */
  /* border: 1px solid rgb(61, 106, 255); */
  font-size: 1.6rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.2rem;
  background: transparent;
  color: #0ff;
  overflow: hidden;
  box-shadow: 0 0 0 0 transparent;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

button:hover {
  /* background: rgb(61, 106, 255); */
  box-shadow: 0 0 30px 5px rgb(0, 142, 236);
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  transition: all 0.3s ease-out;
  background: #3d6aff00;
  transform: scale(1.1);
}

button:hover::before {
  -webkit-animation: sh02 0.5s 0s linear;
  -moz-animation: sh02 0.5s 0s linear;
  animation: sh02 0.5s 0s linear;
}

button::before {
  content: '';
  display: block;
  width: px;
  height: 86%;
  position: absolute;
  top: 7%;
  left: 0%;
  opacity: 0;
  background: #0ff;
  box-shadow: 0 0 50px 30px #fff;
  -webkit-transform: skewX(-20deg);
  -moz-transform: skewX(-20deg);
  -ms-transform: skewX(-20deg);
  -o-transform: skewX(-20deg);
  transform: skewX(-20deg);
}

@keyframes sh02 {
  from {
    opacity: 0;
    left: 0%;
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 0;
    left: 100%;
  }
}

button:active {
  box-shadow: 0 0 0 0 transparent;
  -webkit-transition: box-shadow 0.2s ease-in;
  -moz-transition: box-shadow 0.2s ease-in;
  transition: box-shadow 0.2s ease-in;
}

button:disabled,
button.disabled {
  /* background: rgba(128, 128, 128, 0.3); */
  color: #e2dfdf;
  /* border-color: rgba(192, 192, 192, 0.5); */
  cursor: not-allowed;
  pointer-events: none;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

button:disabled:hover,
button.disabled:hover {
  box-shadow: none;
  background: rgba(128, 128, 128, 0.3);
}

button:disabled::before,
button.disabled::before {
  display: none;
}
</style>
